import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router';
import routes from './routes';
import qs from 'qs';

Vue.use(VueRouter)

export default  new VueRouter({
    mode: 'history',    
    /*
    parseQuery(query) {
        // try to fix '+' query string param start
        try {
            var queryString = query+"";
            if (queryString.length) {
                var temp_query = "";
                var keyValPairs = queryString.split('&');
                var par = "";
                var key = "";
                var val = null;
                for (var pairNum = 0; pairNum < keyValPairs.length; pairNum++) {
                    try {
                        par = keyValPairs[pairNum];
                        par = decodeURIComponent(par);
                        key = par.substring(0, par.indexOf("="));
                        val = par.substring(par.indexOf("=") + 1, par.length);
                        if (!key.length) continue;
                        temp_query = temp_query + (temp_query == "" ? "" : "&") + key + "=" + encodeURIComponent(val);
                    } catch (ee) {}
                }
                if (temp_query != "")
                    query = temp_query+"";
            }
        } catch (e) { }
        // try to fix '+' query string param end
        return qs.parse(query);
    },
    */
    routes
})